import React from 'react';
import { Button } from 'lib/@mui';
import { Add as AddIcon } from 'lib/@mui/Icons';

import { useTranslate } from '../../../../languages';
import { EZLOGIC_TITLE_CREATE_NEW_LABEL } from '../../../../../constants/language_tokens';

import styles from './styles.module.scss';

const CreateLabelButton = ({ onClick }) => {
    const { t } = useTranslate();

    return (
        <div className={styles.createLabelButtonWrapper}>
            <Button variant="contained" startIcon={<AddIcon />} color="primary" fullWidth onClick={onClick}>
                {t(EZLOGIC_TITLE_CREATE_NEW_LABEL)}
            </Button>
        </div>
    );
};

export default CreateLabelButton;
